export default [
    {
        method: 'login',
        type: 'POST',
        path: '/web/game/login',
        mode: 'passport',
        params: ["user", "pwd", "captcha", "keep", "gourl"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '登录'
    },
    {
        method: 'emailLogin',
        type: 'POST',
        path: '/web/login',
        mode: 'passport',
        params: ["user", "pwd", "captcha", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '邮箱登录'
    },
    {
      method: "loginSns",
      type: 'POST',
      path: '/web/game/login/sns',
      mode: 'passport',
      params: ["channel_type", "type", "access_key", "changeBaseUrl"],
      options: { withCredentials: true, cache: false },
      switch: false,
      // desc: '第三方登录'
    },
    {
      method: "loginOldSns",
      type: 'POST',
      path: '/web/game/login/sns',
      mode: 'passport',
      params: ["channel_type", "type", "access_key", "gourl"],
      options: { withCredentials: true, cache: false },
      switch: false,
      // desc: '第三方登录'
    },
    {
        method: "getPublicKey",
        type: 'GET',
        path: '/web/game/login/get_key',
        mode: 'passport',
        params: [],
        options: { cache: false },
        switch: false,
        // desc: '登录获取public_ley'
    },
    {
        method: "getEmailPublicKey",
        type: 'GET',
        path: '/web/login/get_key',
        mode: 'passport',
        params: ["changeBaseUrl"],
        options: { cache: false },
        switch: false,
        // desc: '邮箱登录获取public_ley'
    },
    {
        method: "getRequestToken",
        type: 'POST',
        path: '/web/game/request/token',
        mode: 'passport',
        params: ["channel_type", "oauth_callback"],
        options: { cache: false },
        switch: false,
        // desc: 'twitter登录获取requestToken'
    },
    {
        method: "getAccessToken",
        type: 'POST',
        dataFormat: 'string',
        path: '/web/game/access/token',
        mode: 'passport',
        params: ["channel_type", "oauth_token", "oauth_verifier"],
        options: { cache: false },
        switch: false,
        // desc: 'twitter登录获取accessToken'
    }
];